import React, { useState } from "react";
import { Card } from "@pericles/framework-frontend";

import { ProjectsListScreen } from "./ProjectsListScreen";
import { ProjectInputDataPanel } from "./ProjectInputDataPanel";
import { PageShell } from "./ui";

interface InputDataScreenProps {
  activeCustomerId: string;
  onActiveCustomerChange: (customerId: string) => void;
}

export function InputDataScreen({ activeCustomerId, onActiveCustomerChange }: InputDataScreenProps): JSX.Element {
  const [selectedProjectId, setSelectedProjectId] = useState<string | number | null>(null);
  const [selectedProjectName, setSelectedProjectName] = useState<string>("");

  return (
    <PageShell>
      <ProjectsListScreen
        key={`input-data-projects-${activeCustomerId}`}
        entityName="Project"
        activeCustomerId={activeCustomerId}
        onActiveCustomerChange={onActiveCustomerChange}
        onRowClick={(row: any) => {
          const id = (row as any)?.id ?? null;
          setSelectedProjectId(id);
          setSelectedProjectName((row as any)?.name ?? "");
        }}
        title="Input data"
      />

      <Card>
        <div className="p-4">
          {selectedProjectId ? (
            <ProjectInputDataPanel projectId={String(selectedProjectId)} projectName={selectedProjectName} />
          ) : (
            <p className="text-sm text-slate-600">
              Sélectionnez un projet dans la liste pour uploader des PDF, définir le contexte et discuter avec l'agent IA.
            </p>
          )}
        </div>
      </Card>
    </PageShell>
  );
}
